import { Kaggle } from "@kaggle/sdk";
import { getServices } from "../../../../api/getServices";
import { normalizeAmbiguousErrorMessages } from "../../../utils/ambiguousErrors";
import { setNonfatalErrorMessage } from "../editor";
type UpdateKernelSessionRequest = Kaggle.Sdk.Kernels.UpdateKernelSessionRequest;

export const updateKernelSession = async (
  params: UpdateKernelSessionRequest
) => {
  const services = getServices();

  try {
    let errorText = "";
    const session = await services.kernelsClient.kernelsService
      .updateKernelSession(params)
      .catch(err => {
        errorText = err;
      });
    if (errorText || !session) {
      throw new Error(errorText || "Failed to update kernel session.");
    }
    return session;
  } catch (error) {
    const messages = normalizeAmbiguousErrorMessages(error);
    setNonfatalErrorMessage(messages.join(", "));
    throw error;
  }
};
